import dynamic from "next/dynamic";

import { Loader } from "components/customElements/loader";

import useFinancialData from "./useFinancialData";

const StackedColumnChart = dynamic(
  () => import("components/AmChart/StackedColumnChart"),
  {
    ssr: false,
  }
);

const RBGChartConfig = {
  title: "Revenue By Geography",
};

const RBBSChartConfig = {
  title: "Revenue By Business Segment",
};

interface Props {
  entity: any;
}

const Segments = ({ entity }: Props) => {
  const { regionalSegments, businessSegments, isLoading } = useFinancialData(
    entity?.isin || ""
  );

  if (isLoading) return <Loader />;

  const chartClass = "h-[600px] mb-[80px]";
  return (
    <>
      <div className={chartClass}>
        <StackedColumnChart
          chartData={regionalSegments}
          chartConfig={RBGChartConfig}
          className={chartClass}
        />
      </div>
      <div className={chartClass}>
        <StackedColumnChart
          chartData={businessSegments}
          chartConfig={RBBSChartConfig}
          className={chartClass}
        />
      </div>
    </>
  );
};

export default Segments;
